import { createActionConst } from '../../../utils/action.utils';

const KPI_NAMESPACE = 'KPI_NAMESPACE';

export const STORE_KPI = createActionConst(KPI_NAMESPACE, 'STORE_KPI');
export const CLEAR_KPI = createActionConst(KPI_NAMESPACE, 'CLEAR_KPI');
